import Garnishes from "@/Components/FastExtras/Garnishes";
import Inner from "@/Components/FastExtras/Inner";
import Selected from "@/Components/FastExtras/Selected";
import Toppings from "@/Components/FastExtras/Toppings";
import { useModalMeta } from "@/shared/atoms/useModal";
import useMenuItemHook from "@/shared/hooks/useMenuItemHook";
import { MenuItems } from "@/shared/utils/enum";
import { Garnish, Topping } from "@/shared/utils/interfaces";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import Modal, { ModalProps } from "../Modal/Modal";
import Spinner from "../Spinner/Spinner";

const MenuFastExtrasModal = ({ onExit, ...props }: ModalProps) => {
  const [{ product }] = useModalMeta();
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const garnishQuery = useMenuItemHook<Garnish[]>(MenuItems.GARNISH, false);
  const toppingQuery = useMenuItemHook<Topping[]>(MenuItems.TOPPING, false);

  return (
    <Modal fullHeight className="md:w-2/3!" onExit={onExit} {...props}>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList className="flex gap-4">
          {product && (
            <Tab>
              <Inner selected={tabIndex === 0}>{t("select")}</Inner>
            </Tab>
          )}
          <Tab>
            <Inner
              selected={product ? tabIndex === 1 : tabIndex === 0}
              variants="utensils"
            >
              {t("menu.extraCategoryManage")}
            </Inner>
          </Tab>
          <Tab>
            <Inner
              selected={product ? tabIndex === 2 : tabIndex === 1}
              variants="seedling"
            >
              {t("menu.extraManage")}
            </Inner>
          </Tab>
        </TabList>

        {garnishQuery.isFetching || toppingQuery.isFetching ? (
          <Spinner />
        ) : (
          <>
            {product && (
              <TabPanel>
                <Selected product={product} query={garnishQuery} />
              </TabPanel>
            )}
            <TabPanel>
              <Garnishes
                setTabIndex={setTabIndex}
                garnishQuery={garnishQuery}
                toppingQuery={toppingQuery}
              />
            </TabPanel>
            <TabPanel>
              <Toppings
                garnishQuery={garnishQuery}
                toppingQuery={toppingQuery}
              />
            </TabPanel>
          </>
        )}
      </Tabs>
    </Modal>
  );
};

export default MenuFastExtrasModal;
